import { render, staticRenderFns } from "./TblDeviceDetail.vue?vue&type=template&id=0ff7a211&scoped=true&"
import script from "./TblDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./TblDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblDeviceDetail.vue?vue&type=style&index=0&id=0ff7a211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7a211",
  null
  
)

export default component.exports